module.exports = __webpack_public_path__ + "static/media/wellstat.23969050.jpg";